<template>
    <article
        class="pt-5 pb-1 w-90-per border-b border-divider m-auto text-left"
        :class="isHidden"
        data-cy="newsCard"
        :aria-label="type"
    >
        <Header :title="cleanTitle" :pubDate="pubDate" :type="type" :link="link" />
        <CollapsableText
            v-if="subtitle"
            class="pl-2 pr-2 overflow-hidden"
            :title="cleanTitle"
            :subtitle="cleanSubtitle"
            :link="link"
            :maxSubtitleLength="maxSubtitleLength"
        />

        <CardFooter
            :showExpandButton="subtitleLongerThanMax"
            :link="link"
            v-on:toggleModal="modal()"
        />
    </article>
</template>

<script>
import Header from "@/components/NewsCard/Header";
import CollapsableText from "@/components/NewsCard/CollapsableText";
import CardFooter from "@/components/CardFooter";

export default {
    name: "NewsCard",
    components: {
        Header,
        CollapsableText,
        CardFooter,
    },
    props: {
        title: {
            required: true,
            type: String,
        },
        subtitle: {
            required: false,
            type: String,
        },
        pubDate: {
            required: true,
            type: String,
        },
        heroImage: {
            required: false,
            type: String,
        },
        link: {
            required: false,
            type: String,
        },
        videoId: {
            required: false,
            type: String,
        },
        type: {
            required: true,
            type: String,
        },
        isModalShown: {
            required: false,
            type: Boolean,
        },
    },
    data() {
        return {
            maxSubtitleLength: 200,
        };
    },
    computed: {
        /**
         * Checks to see if the subtitle is longer than the max string length
         *
         * @returns if the subtitle is longer than max
         */
        subtitleLongerThanMax: function() {
            return this.subtitle && this.subtitle.length > this.maxSubtitleLength;
        },
        /**
         * Checks to see if the `isModalShown` is true|false
         */
        isHidden: function() {
            if (this.isModalShown) {
                return "hidden";
            } else {
                return "";
            }
        },
        /**
         *  Clean title for display
         */
        cleanTitle: function() {
            return this.title.replace(/\\"/g, '"');
        },
        /**
         *  Clean subtitle for display
         */
        cleanSubtitle: function() {
            return this.subtitle.replace(/\\"/g, '"');
        },
    },
    methods: {
        /**
         * click event
         */
        modal() {
            // just got to send it
            this.$emit("toggleModal");
        },
    },
};
</script>
